export default __webpack_public_path__ + "static/media/ApplicationForm.42d66a35.jpeg";